import { Injectable, inject } from '@angular/core';
import { CanActivate, GuardResult, MaybeAsync, Router } from '@angular/router';
import { AuthenticationStateService } from 'app/shared/services/state/authentication-state.service';

@Injectable({
  providedIn: 'root',
})
export class PasswordGuard implements CanActivate {
  private router = inject(Router);
  private authenticationStateService = inject(AuthenticationStateService);

  canActivate(): MaybeAsync<GuardResult> {
    if (this.authenticationStateService.password()) {
      return true;
    }

    const storedPassword = sessionStorage.getItem('password');
    if (storedPassword) {
      this.authenticationStateService.setPassword(storedPassword);
      return true;
    }

    return this.router.parseUrl('auth');
  }
}
